import { makeStyles } from '@material-ui/core/styles';
import ShieldIcon from "../icons/shield-icon.svg";

const useDashboardStyles = makeStyles(() => ({
  complianceContainer: {
    position: 'relative',
    width: '95%',
    left:'50px',
    zIndex: '1',
    overflow: 'hidden'
  },
  topBar: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1rem',
    width: '100%',
    padding: '1rem',
    boxSizing: 'border-box',
  },
  leftControls: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '1rem',
  },
  tileContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    padding: '1rem',
    boxSizing: 'border-box',
  },
  headerWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: '0 0 auto',
  },
  headerIconShield: {
    backgroundImage: `url(${ShieldIcon})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    width: 'clamp(1.2rem, 3vw, 2rem)',
    height: 'clamp(1.2rem, 3vw, 2rem)',
    flexShrink: 0,
  },
  headerTitle: {
    fontSize: 'clamp(0.8rem, 2.5vh, 1.5rem)',
    margin: 0,
  },
  headerIcon: {
    fontSize: 'clamp(1rem, 2vw, 1.5rem)',
    color: '#e0123c',
    flexShrink: 0,
  },
  title: {
    fontSize: 'clamp(1rem, 2vw, 1.5rem)',
    margin: 0,
  },
  icon: {
    width: 'clamp(1.5rem, 2.5vw, 2rem)',
    height: 'clamp(1.5rem, 2.5vw, 2rem)',
    color: '#e0123c',
    flexShrink: 0, // prevent shrinking on smaller screens
    marginLeft: '10px',
    marginTop: '10px'
  },
  statusTextWrapper: {
    textAlign: 'left',
    padding: '0 8px',
  },
  statusText: {
    lineHeight: 1.4,
    wordBreak: 'break-word',
  },
   listItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '10px 12px',
    listStyle: 'none',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    transition: 'background 0.2s ease',
    '&:hover': {
      backgroundColor: '#f1f1f1',
    },
  },
  field: {
    fontSize: 'clamp(0.85rem, 1.5vw, 1rem)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  name: {
    flex: 2,
  },
  owner: {
    flex: 1.5,
  },
  date: {
    flex: 1,
  },
  status: {
    height: '12px',
    width: '12px',
    borderRadius: '50%',
    flexShrink: 0,
  },
  greenStatus: {
    backgroundColor: '#4caf50',
  },
  redStatus: {
    backgroundColor: '#f44336',
  }
}));

export default useDashboardStyles;
